import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const appInsights = new ApplicationInsights({
    config: {
        connectionString: process.env.VUE_APP_APPLICATIONINSIGHTS, // Application Insights の接続文字列
        enableAutoRouteTracking: true, // ページビューの自動追跡
    },
});

appInsights.loadAppInsights();

export default appInsights;
